export const ListTheme = {
    List: {
        baseStyle: {
            py: 0,
            px: 0,
            borderWidth: 0
        },
    },
    ListItem: {
        baseStyle: {
            py: 0,
        }
    }
}